var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{staticClass:"btn btn-secondary",attrs:{"to":_vm.localePath({name: 'auth-actie-vereist'}),"rel":"nofollow noopener noreferrer"}},[_c('icons-user',{staticClass:"ml-1 mr-2"}),_vm._v("\n    Inloggen\n  ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }